import { render, staticRenderFns } from "./goodsteam.vue?vue&type=template&id=2aa00887&scoped=true"
import script from "./goodsteam.vue?vue&type=script&lang=js"
export * from "./goodsteam.vue?vue&type=script&lang=js"
import style0 from "./goodsteam.vue?vue&type=style&index=0&id=2aa00887&prod&lang=css"
import style1 from "./goodsteam.vue?vue&type=style&index=1&id=2aa00887&prod&lang=scss&scoped=true"
import style2 from "./goodsteam.vue?vue&type=style&index=2&id=2aa00887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa00887",
  null
  
)

export default component.exports